export default __webpack_public_path__ + "static/UniversalJungle-420-c921f083d922a8b1e903a47a14c8a75a.woff2";